import { UPDATE_ALLOW_INPUT } from '../actions';

export const allowInput = (state = true, action) => {
  switch (action.type) {
    case UPDATE_ALLOW_INPUT: {
      return action.allowInput;
    }
    default:
      return state;
  }
};
